import { useEffect, useState } from 'react'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'
import { getMapHeadTitles } from '../consts/table.consts'
import { useGetCategories } from './useGetCategories'
import { requestsPaginationStore, useRequestsData } from './useRequestsData'

const SCROLL_DELAY_MS = 0
const SMALL_DATA_THRESHOLD = 50

export const useRequestsTable = (openRequestDetails: any, filterStore: any) => {
  const [renderTable, setRenderTable] = useState(false)
  const {
    scrollHeight,
    sort,
    setSort,
    selectedRow,
    setSelectedRow,
    resetParams,
  } = requestsPaginationStore

  const {
    data,
    isLoading: isDataLoading,
    isFetching,
  } = useRequestsData(filterStore)
  const { data: categories, isLoading: isCategoriesLoading } =
    useGetCategories()

  const requestsData = data?.content || []
  const isFetchingInProgress =
    isDataLoading || isFetching || isCategoriesLoading
  const isSmallLength = requestsData.length < SMALL_DATA_THRESHOLD

  // Обработчик сортировки
  const handleSort = (key: string) => {
    setRenderTable(false)
    setSort(`-${key.toLowerCase()}`)
  }

  // Обработчик клика по строке
  const handleRowClick = (el: RequestType) => {
    setSelectedRow(el, window.scrollY)
    openRequestDetails({ data: el })
  }

  useEffect(() => {
    window.scrollTo(0, 0)

    let timeoutId: NodeJS.Timeout
    if (!isFetchingInProgress) {
      timeoutId = setTimeout(() => {
        setRenderTable(true)
      }, SCROLL_DELAY_MS)
    }

    return () => {
      resetParams()
      clearTimeout(timeoutId)
    }
  }, [])

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null

    if (requestsData.length || !isFetchingInProgress) {
      timer && clearTimeout(timer)

      timer = setTimeout(() => {
        setRenderTable(true)
        if (scrollHeight) {
          window.scrollTo(0, scrollHeight)
        }
      }, SCROLL_DELAY_MS)
    }

    return () => {
      timer && clearTimeout(timer)
    }
  }, [requestsData.length, renderTable, isFetchingInProgress])

  // Получаем заголовки таблицы
  const mapHeadTitles = getMapHeadTitles()
  const columns = Object.keys(mapHeadTitles)

  return {
    isSmallLength,
    setRenderTable,
    isLoading: isFetchingInProgress || !renderTable,
    data,
    mapHeadTitles,
    sort,
    onSort: handleSort,
    selectedRow,
    columns,
    onRowClick: handleRowClick,
    categories,
  }
}
